export default "https://static-website.miro.com/miro-site-lp-build-assets/_next/static/chunks/fonts/formular-medium-d390ef5d4f3589658bd593254f43a3c7.woff2";